// export for HubspotForm.tsx
export const DEFAULT_HUBSPOT_PORTAL_ID = '2668862'

export const HUBSPOT_FORM_IDS = {
  BOOK_A_DEMO: '688edd07-84fc-4e56-9ad4-88778dfe8558',
  CONTACT_SALES: '6b379963-9ac9-4001-89bf-d5dd17a1d3be',
} as const
